export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='https://commerce.coinbase.com/checkout/a85a9375-974f-4809-97e1-46912a3e5a45'>
          LGBTQIACOM !!
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#campaigns' className='page-scroll'>
                Campaigns
              </a>
            </li>
            <li>
              <a href='#about' className='page-scroll'>
                About
              </a>
            </li>
            <li>
              <a href='#pride' className='page-scroll'>
                Pride
              </a>
            </li>
            <li>
              <a href='#references' className='page-scroll'>
                References
              </a>
            </li>
            <li>
              <a href='https://commerce.coinbase.com/checkout/a85a9375-974f-4809-97e1-46912a3e5a45' className='btn btn-custom btn-lg page-scroll'>
                Contribute
              </a>
            </li>       
          </ul>
        </div>
      </div>
    </nav>
  )
}
